import { useMutation } from '@apollo/client'
import { ConfirmationDialog } from '@sitoo/mui-components'
import { Trans, useTranslation } from 'react-i18next'
import { ResetPasswordDocument } from '../../../generated/graphql'
import { ConnectionInformationDialog } from './connection-information-dialog'
import { enqueueSnackbar } from 'notistack'

type Props = {
  open: boolean
  onClose: () => void
  apiKeyId: number
  name: string
}

export const ResetApiKeyDialog = (props: Props) => {
  const { open, onClose, apiKeyId, name } = props
  const { t } = useTranslation(['api_keys', 'shared'])
  const [resetPassword, { data, reset }] = useMutation(ResetPasswordDocument, {
    onError: (error) => {
      enqueueSnackbar(
        t('api_keys:reset_password_error', { error: error.message }),
        { variant: 'error' },
      )
      onClose()
    },
  })

  const newPasswordData = data?.resetPassword

  return (
    <>
      <ConfirmationDialog
        open={open && !newPasswordData}
        onClose={onClose}
        title={t('api_keys:reset_password_title')}
        text={
          <Trans
            i18nKey="api_keys:reset_password_confirmation"
            values={{ name }}
            components={{ strong: <strong /> }}
          />
        }
        confirmAction={async () => {
          await resetPassword({ variables: { apiKeyId } })
        }}
        variant="destructive"
        mainActionLabel={t('api_keys:reset_password_button')}
      />

      <ConnectionInformationDialog
        open={open && !!newPasswordData}
        onClose={() => {
          onClose()
          reset()
        }}
        credentials={newPasswordData}
      />
    </>
  )
}
